// s101 map review (Dr. Rami, Build 67: "opens very zoomed out", "every time I zoom in it auto zooms
// out", "scrolling around the map is clunky"). The two camera decisions of DoctorsMap, pure, so the
// gate check-map-camera runs them.

const R = 3958.8
export const milesBetweenPts = (a, b) => {
  const rad = (x) => (x * Math.PI) / 180
  const dLat = rad(b.lat - a.lat), dLng = rad(b.lng - a.lng)
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)))
}

/** The half-width (miles) to frame around the patient: the closest 8 pins inside the search distance,
 *  always reaching the nearest Orella doctor; never under 2 mi, never over the distance; 10 mi
 *  (or the distance) with no pin inside it. */
export function nearestViewMiles(center, doctors, radiusMiles, orellaOf) {
  const near = (doctors || [])
    .filter((d) => d && d.practice_lat != null && d.practice_lng != null)
    .map((d) => ({ d, mi: milesBetweenPts(center, { lat: Number(d.practice_lat), lng: Number(d.practice_lng) }) }))
    .filter((x) => Number.isFinite(x.mi) && x.mi <= radiusMiles)
    .sort((x, y) => x.mi - y.mi)
  if (!near.length) return Math.min(radiusMiles, 10)
  let reach = near[Math.min(near.length, 8) - 1].mi
  const firstOrella = typeof orellaOf === 'function' ? near.find((x) => orellaOf(x.d)) : null
  if (firstOrella) reach = Math.max(reach, firstOrella.mi)
  return Math.min(radiusMiles, Math.max(2, reach * 1.15))
}

/** The search a camera position belongs to. With a search distance the doctor array is NOT part of
 *  it (a screen builds a new array every render); without one (the Doctors screens frame their
 *  pins) the set of doctor ids is. */
export function cameraViewKey({ center, centerPrecise, fitRadiusMiles, doctors }) {
  const r3 = (v) => (typeof v === 'number' ? v.toFixed(3) : '-')
  const radius = Number.isFinite(fitRadiusMiles) && fitRadiusMiles > 0
  const idSet = radius ? '' : (doctors || []).map((d) => String(d && d.id)).sort().join(',')
  return `${r3(center && center.lat)},${r3(center && center.lng)}|${radius ? fitRadiusMiles : '-'}|${centerPrecise ? 1 : 0}|${idSet}`
}

/** What the camera does on a render: 'fit', 'hold' (a new search the patient already framed, i.e.
 *  "Search this area"), or 'none'. state = { key, fittedWithPins, userTookOver, lastReported }. */
export function cameraStep(state, { viewKey, hasPins, center }) {
  if (viewKey !== state.key) {
    const lr = state.lastReported
    const held = !!(lr && center && Math.abs(lr.lat - center.lat) < 0.002 && Math.abs(lr.lng - center.lng) < 0.002)
    return { action: held ? 'hold' : 'fit', state: { ...state, key: viewKey, userTookOver: held, fittedWithPins: held || hasPins } }
  }
  if (hasPins && !state.fittedWithPins && !state.userTookOver) {
    return { action: 'fit', state: { ...state, fittedWithPins: true } }
  }
  return { action: 'none', state }
}
